const testimonials = [
  {
    name: 'Kofi Mensah',
    role: 'Étudiant en France',
    image: 'https://public.readdy.ai/ai/img_res/59f565b98f0add6d1842439b65725f78.jpg',
    rating: 5,
    text: 'Grâce à Clé Visa, j\'ai obtenu mon visa étudiant pour la France en moins de 3 semaines. Leur accompagnement était exceptionnel, du choix de l\'université jusqu\'à la préparation de l\'entretien consulaire. Je recommande vivement leurs services !'
  },
  {
    name: 'Amina Diallo',
    role: 'Entrepreneure',
    image: 'https://readdy.ai/api/search-image?query=Professional%20African%20businesswoman%20in%20her%20thirties%20wearing%20elegant%20business%20attire%20holding%20passport%20with%20confident%20smile%2C%20simple%20clean%20white%20background%2C%20natural%20lighting%2C%20high%20quality%20portrait%20photography%2C%20realistic%2C%208k%20resolution&width=400&height=400&seq=testimonial-business-1&orientation=squarish',
    rating: 5,
    text: 'J\'avais essuyé un refus de visa affaires. L\'équipe de Clé Visa a analysé mon dossier, identifié les problèmes et m\'a aidée à constituer un nouveau dossier solide. Résultat : visa obtenu ! Professionnalisme et expertise au rendez-vous.'
  },
  {
    name: 'Jean-Baptiste Kouassi',
    role: 'Visa Tourisme Canada',
    image: 'https://readdy.ai/api/search-image?query=Professional%20African%20male%20in%20his%20forties%20wearing%20casual%20elegant%20clothing%20holding%20passport%20and%20travel%20documents%20with%20joyful%20expression%2C%20simple%20clean%20white%20background%2C%20natural%20lighting%2C%20high%20quality%20portrait%20photography%2C%20realistic%2C%208k%20resolution&width=400&height=400&seq=testimonial-tourist-1&orientation=squarish',
    rating: 5,
    text: 'Service impeccable ! La préparation à l\'entretien consulaire m\'a donné une confiance totale. Les conseils étaient précis et les simulations très réalistes. Mon visa tourisme pour le Canada a été approuvé du premier coup. Merci Clé Visa !'
  },
  {
    name: 'Fatou Traoré',
    role: 'Regroupement Familial',
    image: 'https://readdy.ai/api/search-image?query=Professional%20African%20woman%20in%20her%20thirties%20wearing%20traditional%20elegant%20clothing%20holding%20passport%20with%20warm%20happy%20smile%2C%20simple%20clean%20white%20background%2C%20natural%20lighting%2C%20high%20quality%20portrait%20photography%2C%20realistic%2C%208k%20resolution&width=400&height=400&seq=testimonial-family-1&orientation=squarish',
    rating: 5,
    text: 'Après des mois de démarches infructueuses, Clé Visa a pris en charge mon dossier de regroupement familial. Leur expertise et leur suivi constant ont fait toute la différence. Je suis maintenant réunie avec ma famille en Belgique.'
  },
  {
    name: 'Yao Koffi',
    role: 'Visa Étudiant USA',
    image: 'https://readdy.ai/api/search-image?query=Professional%20African%20male%20student%20in%20his%20early%20twenties%20wearing%20modern%20casual%20clothing%20holding%20passport%20and%20university%20documents%20with%20excited%20expression%2C%20simple%20clean%20white%20background%2C%20natural%20lighting%2C%20high%20quality%20portrait%20photography%2C%20realistic%2C%208k%20resolution&width=400&height=400&seq=testimonial-student-2&orientation=squarish',
    rating: 5,
    text: 'Le processus pour obtenir un visa étudiant américain est complexe, mais Clé Visa m\'a guidé à chaque étape. De la recherche d\'université à l\'obtention du visa, tout était parfaitement organisé. Je pars étudier aux USA le mois prochain !'
  },
  {
    name: 'Mariama Sow',
    role: 'Visa Affaires Allemagne',
    image: 'https://readdy.ai/api/search-image?query=Professional%20African%20businesswoman%20in%20her%20late%20thirties%20wearing%20professional%20business%20suit%20holding%20passport%20with%20confident%20professional%20expression%2C%20simple%20clean%20white%20background%2C%20natural%20lighting%2C%20high%20quality%20portrait%20photography%2C%20realistic%2C%208k%20resolution&width=400&height=400&seq=testimonial-business-2&orientation=squarish',
    rating: 5,
    text: 'La rédaction professionnelle de ma lettre d\'intention et de mes justificatifs financiers a été déterminante. Clé Visa comprend vraiment ce que les consulats recherchent. Mon visa affaires pour l\'Allemagne a été approuvé sans problème.'
  }
];

export default function TestimonialsSection() {
  return (
    <section id="temoignages" className="py-24 bg-gradient-to-br from-blue-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-teal-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-chat-quote-line text-teal-600"></i>
            <span className="text-teal-700 text-sm font-semibold">Témoignages</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Ce Que Disent Nos Clients
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Des centaines de clients satisfaits qui ont réalisé leurs projets internationaux avec Clé Visa
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>

              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              <p className="text-gray-700 leading-relaxed italic">
                "{testimonial.text}"
              </p>

              <div className="mt-6 pt-6 border-t border-gray-100">
                <div className="flex items-center text-sm text-teal-600">
                  <i className="ri-checkbox-circle-fill mr-2"></i>
                  <span className="font-semibold">Visa Obtenu</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <p className="text-lg text-gray-600 mb-6">
            Rejoignez des centaines de clients satisfaits qui ont réalisé leurs rêves internationaux
          </p>
          <a 
            href="#contact" 
            className="inline-flex items-center bg-teal-600 text-white px-8 py-4 rounded-full hover:bg-teal-700 transition-all font-semibold text-lg shadow-xl hover:shadow-2xl transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-user-add-line mr-2"></i>
            Commencer Mon Projet
          </a>
        </div>
      </div>
    </section>
  );
}
